import GlobalLoading from './GlobalLoading.vue'
const loading = {
  install (Vue: any) {
    Vue.component('Loading', GlobalLoading)
  }
}
export default loading
